
<template>
  <div>
    <p v-html="routeText"></p>
    <b-alert show variant="danger" v-if="submitError">{{ submitError }}</b-alert>
    <input type="text" class="form-control mb-4" v-model="code" :placeholder="$t('base.errors.unauthozed-travel-error-page.new-code')" />
    <div v-if="isGenericCode">
      <base-input v-model="reservationNumber" :placeholder="$t('base.errors.unauthozed-travel-error-page.new-reservation-number')"></base-input>
      <b-row>
        <b-col cols="6">
          <base-datepicker v-model="startDate" :placeholder="$t('base.errors.unauthozed-travel-error-page.new-start-date')"></base-datepicker>
        </b-col>
        <b-col cols="6">
          <base-datepicker v-model="endDate" :placeholder="$t('base.errors.unauthozed-travel-error-page.new-end-date')"></base-datepicker>
        </b-col>
      </b-row>
    </div>
    <base-button @click="send">{{ $t('continue') }}</base-button>
  </div>
</template>

<script>
import CompaniesRepository from '@/repositories/CompaniesRepository'

export default {
  data () {
    return {
      code: null,
      isGenericCode: false,
      reservationNumber: null,
      startDate: null,
      endDate: null,
      submitError: null
    }
  },
  computed: {
    routeText () {
      return this.$store.state.errorPageMessage
    }
  },
  watch: {
    code (val) {
      CompaniesRepository.getCode(val).then((response) => {
        this.isGenericCode = response.data.generic
      })
    }
  },
  methods: {
    send () {
      // Check fields
      if (!this.code) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.code-required')
      } else if (this.genericCode && !this.reservationNumber) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.reservation-number-required')
      } else if (this.genericCode && (!this.startDate || !this.endDate || this.startDate > this.endDate)) {
        this.submitError = this.$t('base.errors.unauthozed-travel-error-page.start-date-required')
      } else {
        this.submitError = null
        CompaniesRepository.resetCode(this.code, this.reservationNumber, this.startDate, this.endDate).then((response) => {
          if (response) {
            this.$router.push('/patient')
          } else {
            this.submitError = this.$t('base.errors.unauthozed-travel-error-page.server-error')
          }
        })
      }
    }
  },
  mounted () {
    if (!this.$route.query.t) {
      this.$router.push('/error/unauthorized')
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/errors/UnauthorizedTravelErrorPage.vue